module.exports = __webpack_public_path__ + "img/SKMJ_contract.4878dc75.png";